import React from "react";
import ClinicProfile from "./ClinicProfile";

const LoginProfile = () => {
  return <ClinicProfile defaultTab="user" />;
};

export default LoginProfile;
